import { type IIToastContext, type Toast } from "@repo/utils";
import { type ReactNode, createContext, useContext } from "react";

interface Props {
  children: ReactNode;
}

const ToastContext = createContext<IIToastContext>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateToast: () => {},
});

export const ToastProvider = ({ children }: Props) => {
  const updateToast = (theToast: Toast) => {
    window.xdk?.notifier?.add({
      id: `${theToast.title}_${theToast.id}`,
      title: theToast.title,
      message: theToast.message ?? " ",
      type: theToast.type ?? "info",
      undismissible: false,
      transient: theToast.sticky ?? true,
      button: theToast.button,
    });
  };
  return (
    <ToastContext.Provider
      value={{
        updateToast,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
